(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6151],{

/***/ 528218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";

var _interopRequireDefault = __webpack_require__(564836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(864938));
var _jsxRuntime = __webpack_require__(785893);
var _default = exports["default"] = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'StarSharp');

/***/ }),

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx
// import React, { useState } from 'react';
// import Image, { ImageProps } from 'next/image';
// /* --- shimmer helpers --- */
// const toBase64 = (str: string) =>
//   typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
// const shimmer = (w = 700, h = 475) => `
// <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//   <defs>
//     <linearGradient id="g">
//       <stop stop-color="#f6f7f8" offset="0%" />
//       <stop stop-color="#eaeaea" offset="50%" />
//       <stop stop-color="#f6f7f8" offset="100%" />
//     </linearGradient>
//   </defs>
//   <rect width="${w}" height="${h}" fill="#f6f7f8"/>
//   <rect id="r" width="${w}" height="${h}" fill="url(#g)">
//     <animateTransform attributeName="transform" attributeType="XML"
//       type="translate" from="-${w} 0" to="${w} 0" dur="1s" repeatCount="indefinite" />
//   </rect>
// </svg>`;
// const shimmerDataURL = (w?: number, h?: number) =>
//   `data:image/svg+xml;base64,${toBase64(shimmer(w ?? 700, h ?? 475))}`;
// /* --- typed props like your original component --- */
// type TNextImage<T extends boolean = false> = T extends true
//   ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
//   : { useDefaultHTMLTag?: false } & ImageProps;
// /* --- main component --- */
// export default function NextImage<T extends boolean = false>(props: TNextImage<T>) {
//   const [normalImageLoaded, setNormalImageLoaded] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   // native <img> mode
//   if ((props as any).useDefaultHTMLTag) {
//     const {
//       onLoad,
//       style,
//       width = '100%',
//       height = '100%',
//       ...rest
//     } = props as any;
//     const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//       setNormalImageLoaded(true);
//       if (onLoad) onLoad(e);
//     };
//     // ensure wrapper reserves space; if width/height provided use them, fallback to a default height
//     const wrapperStyle: React.CSSProperties = {
//       display: 'inline-block',
//       position: 'relative',
//       overflow: 'hidden',
//       width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
//       height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
//       backgroundImage: !normalImageLoaded ? `url("${shimmerDataURL(16, 9)}")` : undefined,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       ...((style as React.CSSProperties) || {}),
//     };
//     return (
//       <span style={wrapperStyle}>
//         <img
//           {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)}
//           onLoad={handleLoad}
//         />
//       </span>
//     );
//   }
//   // next/image mode
//   const nextProps = props as ImageProps;
//   const { width, height, onLoadingComplete, style } = nextProps as any;
//   // compute small blurDataURL from shimmer (you can also pass a custom blurDataURL prop)
//   const blurData = shimmerDataURL(
//     typeof width === 'number' ? width : 700,
//     typeof height === 'number' ? height : 475
//   );
//   // wrapper ensures a placeholder background while the image is loading
//   const wrapperStyle: React.CSSProperties = {
//     position: nextProps.layout === 'fill' ? 'absolute' : 'relative',
//     display: 'block',
//     width:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : width
//           ? typeof width === 'number'
//             ? `${width}px`
//             : width
//           : undefined,
//     height:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : height
//           ? typeof height === 'number'
//             ? `${height}px`
//             : height
//           : undefined,
//     backgroundImage: !loaded ? `url("${blurData}")` : undefined,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     ...((style as React.CSSProperties) || {}),
//   };
//   return (
//     <div style={wrapperStyle}>
//       <Image
//         {...nextProps}
//         // keep placeholder prop so Next shows blur if it can, but we also have wrapper background as fallback
//         placeholder="blur"
//         blurDataURL={blurData}
//         onLoadingComplete={(res) => {
//           setLoaded(true);
//           if (onLoadingComplete) onLoadingComplete(res);
//         }}
//       />
//     </div>
//   );
// }





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 732090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Testimonials": function() { return /* reexport */ Testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(740872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(751351);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Constants/index.tsx
var Constants = __webpack_require__(26763);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(881241);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useLayoutTypes.tsx
var useLayoutTypes = __webpack_require__(98078);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Utils/index.tsx
var Utils = __webpack_require__(917732);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/globalLoader.tsx
var globalLoader = __webpack_require__(325480);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/TestimonialsBuilder/TestimonialRating.tsx
var TestimonialRating = __webpack_require__(518042);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Components/Card/Rating.tsx



var Rating = function(param) {
    var isContentCenter = param.isContentCenter, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, ratingCount = param.ratingCount, ratingColor = param.ratingColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-flex tw-w-full", isContentCenter ? "tw-justify-center" : "", isLayout4 ? cardAnimationClass : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialRating/* TestimonialRating */.y, {
            ratingCount: ratingCount || 5,
            color: ratingColor || "#F9CC43"
        })
    });
};

// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(442381);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Components/Card/Review.tsx





var Review = function(param) {
    var authorImagePosition = param.authorImagePosition, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, reviewStyles = param.reviewStyles, testimonialData = param.testimonialData, headlineStylesFromConfig = param.headlineStylesFromConfig, reviewStylesFromConfig = param.reviewStylesFromConfig, textAlignmentStyle = param.textAlignmentStyle, isMobile = param.isMobile, listPresentationConfig = param.listPresentationConfig;
    var shouldAdjustReviewLineHeight = function shouldAdjustReviewLineHeight() {
        var ref = listPresentationConfig || {}, numColumnsMobile = ref.numColumnsMobile, numColumnsDesktop = ref.numColumnsDesktop;
        var numColumns = isMobile ? numColumnsMobile : numColumnsDesktop;
        return numColumns === 1;
    };
    var checkTextClamping = function checkTextClamping() {
        if (textContainerRef.current) {
            var isTextClamped = textContainerRef.current.scrollHeight > textContainerRef.current.clientHeight;
            setReviewIsClamped(isTextClamped);
        }
    };
    var getLineClampClass = function getLineClampClass() {
        return isLayout4 ? !isMobile ? "tw-line-clamp-2" : "tw-line-clamp-4" : "tw-line-clamp-4";
    };
    var review = testimonialData.review, headline = testimonialData.headline;
    var ref = (0,react.useState)(false), isReviewClamped = ref[0], setReviewIsClamped = ref[1];
    var ref1 = (0,react.useState)(false), expandReview = ref1[0], setExpandReview = ref1[1];
    var textContainerRef = (0,react.useRef)(null);
    var isProductTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type;
    (0,react.useEffect)(function() {
        checkTextClamping();
        window.addEventListener("resize", checkTextClamping);
        return function() {
            window.removeEventListener("resize", checkTextClamping);
        };
    }, [
        review,
        textContainerRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-flex tw-max-w-[1000px] tw-flex-grow tw-flex-col tw-gap-[12px]", authorImagePosition.top ? "!tw-gap-[12px]" : "", isLayout4 ? cardAnimationClass : ""),
        style: reviewStyles,
        children: [
            !!(headline === null || headline === void 0 ? void 0 : headline.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0",
                style: (0,_object_spread/* default */.Z)({}, headlineStylesFromConfig, textAlignmentStyle),
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(!expandReview && isProductTestimonial && !isLayout4 ? "tw-h-[112px]" : ""),
                style: (0,_object_spread/* default */.Z)({}, reviewStylesFromConfig, shouldAdjustReviewLineHeight() ? {
                    lineHeight: 1.6
                } : {}, textAlignmentStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        ref: textContainerRef,
                        className: classnames_default()("tw-m-0", !expandReview ? getLineClampClass() : ""),
                        children: review
                    }),
                    isReviewClamped && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-mt-[2px] tw-cursor-pointer tw-font-semibold",
                        style: textAlignmentStyle,
                        onClick: function() {
                            return setExpandReview(!expandReview);
                        },
                        children: !expandReview ? "Read more" : "Read less"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Components/Card/AuthorInfo.tsx




var AuthorInfo = function(param) {
    var isContentCenter = param.isContentCenter, authorImagePosition = param.authorImagePosition, isLayout4 = param.isLayout4, cardAnimationClass = param.cardAnimationClass, renderAuthorImage = param.renderAuthorImage, showImage = param.showImage, colorConfig = param.colorConfig, textAlignmentStyle = param.textAlignmentStyle, testimonialData = param.testimonialData, cardFrameConfig = param.cardFrameConfig, authornameStyles = param.authornameStyles, authorProfileStyles = param.authorProfileStyles, _isProductTestimonial = param.isProductTestimonial, isProductTestimonial = _isProductTestimonial === void 0 ? false : _isProductTestimonial, _verifiedBuyer = param.verifiedBuyer, verifiedBuyer = _verifiedBuyer === void 0 ? false : _verifiedBuyer;
    var authorName = testimonialData.authorName, authorDesignation = testimonialData.authorDesignation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-flex tw-w-full  tw-gap-[12px]", isContentCenter && (authorImagePosition.bottom ? "tw-items-center" : "tw-justify-center"), authorImagePosition.bottom ? "tw-flex-col tw-justify-center" : "tw-items-center", isLayout4 ? cardAnimationClass : "", isProductTestimonial && isLayout4 ? "tw-mt-[24px]" : ""),
        children: [
            (authorImagePosition.withAuthorInfo || authorImagePosition.bottom) && !isProductTestimonial && renderAuthorImage(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-flex tw-flex-col tw-gap-[2px] tw-text-[#050505]", isContentCenter && !showImage && "tw-text-center"),
                style: (0,_object_spread/* default */.Z)({
                    color: colorConfig.text
                }, !authorImagePosition.withAuthorInfo ? textAlignmentStyle : {}),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "tw-m-0 ".concat(isLayout4 ? "tw-text-center" : ""),
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authornameStyles), {
                            color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.authorNameColor
                        }),
                        children: authorName || "Anonymous"
                    }),
                    isProductTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-[12px] tw-font-normal tw-mt-[4px] tw-text-[#505050]",
                        children: "Verified buyer"
                    }),
                    !!authorDesignation && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[12px]",
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authorProfileStyles), {
                            color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.designationColor
                        }),
                        children: authorDesignation
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var CardFrameCollection_utils = __webpack_require__(290331);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/ProductTestimonials/ProductTestimonialsConfig.tsx
var ProductTestimonialsConfig = __webpack_require__(766499);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants/index.tsx
var Testimonials_Constants = __webpack_require__(16902);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/Component/ProductImage.tsx








function ProductImage(props) {
    var handleClick = function handleClick() {
        if (productUrl) {
            window.open(productUrl, "_blank");
        }
    };
    var ref, ref1;
    var imageUrl = props.imageUrl, cardFrameConfig = props.cardFrameConfig, index = props.index, _productUrl = props.productUrl, productUrl = _productUrl === void 0 ? "" : _productUrl, listPresentationConfig = props.listPresentationConfig;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var productImageStyle = (0,Utils/* getImageWrapperStyles */.C_)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productImageShape, index);
    var layoutImageConfig = isMobile ? (ref = ProductTestimonialsConfig.PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName]) === null || ref === void 0 ? void 0 : ref.productImageMobileConfig : (ref1 = ProductTestimonialsConfig.PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName]) === null || ref1 === void 0 ? void 0 : ref1.productImageConfig;
    var isLayout2 = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === Testimonials_Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleClick,
        className: "tw-relative tw-flex tw-overflow-hidden tw-cursor-pointer tw-w-[100%] ".concat(isLayout2 && !isMobile ? "tw-min-w-[300px]" : ""),
        style: (0,_object_spread/* default */.Z)({}, productImageStyle, layoutImageConfig || {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: imageUrl,
            loading: "lazy",
            className: "tw-object-cover tw-max-h-[400px] tw-w-[100%]  ".concat(!isMobile ? (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverEffect)] : "", " ")
        })
    });
}
/* harmony default export */ var Component_ProductImage = (ProductImage);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/Component/ProductText.tsx



var LINE_CLAMP_SETTING = {
    layout1: "tw-line-clamp-1",
    layout2: "tw-line-clamp-2",
    layout3: "tw-line-clamp-1",
    layout4: "tw-line-clamp-1"
};
function ProductText(props) {
    var handleClick = function handleClick() {
        if (productUrl) {
            window.open(productUrl, "_blank");
        }
    };
    var productName = props.productName, isContentCenter = props.isContentCenter, _productUrl = props.productUrl, productUrl = _productUrl === void 0 ? "" : _productUrl, listPresentationConfig = props.listPresentationConfig;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var isLayout4 = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === Constants/* COMMON_LAYOUT_TYPE.FOUR */.o_.FOUR;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleClick,
        className: "tw-text-[14px] tw-opacity-70 ".concat(isMobile ? isLayout4 ? "tw-line-clamp-1" : "tw-line-clamp-2 tw-h-[45px]" : (LINE_CLAMP_SETTING === null || LINE_CLAMP_SETTING === void 0 ? void 0 : LINE_CLAMP_SETTING[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName]) || "tw-line-clamp-1", " \n         tw-font-medium tw-leading-[1.6] tw-cursor-pointer tw-underline tw-text-newBlack\n          ").concat(isContentCenter && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) !== Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE ? "tw-text-center" : "", "\n          "),
        children: productName
    });
}
/* harmony default export */ var Component_ProductText = (ProductText);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/constant.ts
var PRODUCT_CONTENT_POSITION = {
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right"
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/Layouts/Layout1.tsx







function Layout1(props) {
    var separatorComp = function separatorComp() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-w-[100%] tw-h-[1px] tw-bg-[#111C36] tw-opacity-20"
        });
    };
    var renderPTLayout = // Render product testimonials layout 1
    function renderPTLayout() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col ".concat(isMobile ? "tw-gap-[16px]" : "tw-gap-[24px]", " "),
            children: [
                !isProductContentTop && childComp(),
                !isProductContentTop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-[100%]",
                    children: separatorComp()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex ".concat(isMobile ? "tw-gap-[16px]" : "tw-gap-[24px]", "  ").concat(isLayout1 ? "tw-flex-col" : "tw-items-center", " ").concat(isContentCenter && isLayout1 ? "tw-items-center" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ProductImage, (0,_object_spread/* default */.Z)({}, props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ProductText, (0,_object_spread/* default */.Z)({}, props))
                        })
                    ]
                }),
                isProductContentTop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-[100%]",
                    children: separatorComp()
                }),
                isProductContentTop && childComp()
            ]
        });
    };
    var childComp = props.childComp, cardFrameConfig = props.cardFrameConfig, isContentCenter = props.isContentCenter, listPresentationConfig = props.listPresentationConfig;
    var isProductContentTop = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPosition) === PRODUCT_CONTENT_POSITION.TOP;
    var isLayout1 = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderPTLayout()
    });
}
/* harmony default export */ var Layouts_Layout1 = (Layout1);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/Layouts/Layout2.tsx






function Layout2(props) {
    var separatorComp = function separatorComp() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-w-[100%] tw-h-[1px] tw-bg-[#111C36] tw-opacity-20"
        });
    };
    var renderLayout2 = function renderLayout2() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex  ".concat(isMobile ? "tw-flex-col tw-gap-[16px]" : "tw-items-center tw-gap-[24px]", " ").concat(!isProductContentLeft ? "tw-flex-row-reverse" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-max-w-[450px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ProductImage, (0,_object_spread/* default */.Z)({}, props))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col ".concat(!isMobile ? "tw-w-[50%] tw-gap-[20px]" : "tw-gap-[16px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ProductText, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-[100%]",
                                children: separatorComp()
                            }),
                            childComp()
                        ]
                    })
                ]
            })
        });
    };
    var childComp = props.childComp, cardFrameConfig = props.cardFrameConfig;
    var isProductContentLeft = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPosition) === PRODUCT_CONTENT_POSITION.LEFT;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderLayout2()
    });
}
/* harmony default export */ var Layouts_Layout2 = (Layout2);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ProductTestimonial/Layouts/Layout4.tsx



function Layout4(props) {
    var renderLayout4 = function renderLayout4() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col",
                    children: childComp()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cardAnimationClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component_ProductText, (0,_object_spread/* default */.Z)({}, props))
                })
            ]
        });
    };
    var childComp = props.childComp, cardAnimationClass = props.cardAnimationClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderLayout4()
    });
}
/* harmony default export */ var Layouts_Layout4 = (Layout4);

// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Components/Card/index.tsx



















var Card = function(props) {
    var getImageStyleByType = function getImageStyleByType(param) {
        var _isVideo = param.isVideo, isVideo = _isVideo === void 0 ? false : _isVideo;
        var ref;
        var style = {};
        if (((ref = props.cardFrameConfig) === null || ref === void 0 ? void 0 : ref.authorImagePosition) === "left") {
            if (isLayout5) {
                style.maxWidth = "300px";
                style.width = "".concat(cardWidth * (40 / 100), "px");
            } else {
                var ref1;
                style.width = "".concat(imageWidth, "px");
                if (isVideo && ((ref1 = props.cardFrameConfig) === null || ref1 === void 0 ? void 0 : ref1.imageShape) === Constants/* IMAGE_TYPES.CIRCLE */.v5.CIRCLE) {
                    style.height = "".concat(imageWidth, "px");
                }
            }
        } else {
            style.width = "".concat(imageWidth, "px");
        }
        return {
            style: style
        };
    };
    var renderAuthorImage = function renderAuthorImage() {
        var ref;
        if (!showImage) return null;
        var isVideo = authorMedia.type === Constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO;
        var styling = getImageStyleByType({
            isVideo: isVideo
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("tw-relative tw-flex tw-overflow-hidden", !(Constants/* REMOVE_GLOBAL_STYLE */.XJ === null || Constants/* REMOVE_GLOBAL_STYLE */.XJ === void 0 ? void 0 : Constants/* REMOVE_GLOBAL_STYLE.includes */.XJ.includes((ref = props.cardFrameConfig) === null || ref === void 0 ? void 0 : ref.imageShape)) ? imageWidth < 60 ? "imgWrapperGlobalStyleMin" : "imgWrapperGlobalStyle" : ""),
            style: (0,_object_spread/* default */.Z)({}, styling.style, props.imageWrapperStyles),
            children: [
                authorMedia.type !== Constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                    src: authorMedia.link || Constants/* DEFAULT_IMAGE */.UF,
                    className: "removeGlobalOverride tw-w-full tw-object-cover",
                    loading: "lazy",
                    decoding: "async",
                    layout: "fill",
                    quality: 50
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: authorMedia.link || Constants/* DEFAULT_IMAGE */.UF,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    style: (0,_object_spread/* default */.Z)({}, styling.style),
                    className: "removeGlobalOverride tw-max-w-full tw-object-cover"
                }),
                showImageLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globalLoader/* GlobalLoader */.k, {
                        type: "loader1"
                    })
                })
            ]
        });
    };
    var renderByDataId = function renderByDataId(id) {
        switch(id){
            case Constants/* ORDER_DATA_IDS.RATING */.PK.RATING:
                var ref;
                return showRatings && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating, {
                    isContentCenter: isContentCenter,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    ratingCount: ratingCount,
                    ratingColor: (ref = props.cardFrameConfig) === null || ref === void 0 ? void 0 : ref.ratingColor
                });
            case Constants/* ORDER_DATA_IDS.REVIEW */.PK.REVIEW:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, {
                    authorImagePosition: authorImagePosition,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    reviewStyles: reviewStyles,
                    testimonialData: props.testimonialData,
                    headlineStylesFromConfig: headlineStylesFromConfig,
                    reviewStylesFromConfig: reviewStylesFromConfig,
                    textAlignmentStyle: textAlignmentStyle,
                    isMobile: props.isMobile,
                    listPresentationConfig: listPresentationConfig
                });
            case Constants/* ORDER_DATA_IDS.AUTHOR_INFO */.PK.AUTHOR_INFO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorInfo, {
                    isContentCenter: isContentCenter,
                    authorImagePosition: authorImagePosition,
                    isLayout4: isLayout4,
                    cardAnimationClass: cardAnimationClass,
                    renderAuthorImage: renderAuthorImage,
                    showImage: showImage,
                    colorConfig: colorConfig,
                    textAlignmentStyle: textAlignmentStyle,
                    testimonialData: props.testimonialData,
                    cardFrameConfig: props.cardFrameConfig,
                    authornameStyles: authornameStyles,
                    authorProfileStyles: authorProfileStyles,
                    isProductTestimonial: isProductTestimonial,
                    verifiedBuyer: verifiedBuyer
                });
            default:
                return null;
        }
    };
    var getDataByOrder = function getDataByOrder() {
        return props.dataOrder.map(function(data) {
            return renderByDataId(data === null || data === void 0 ? void 0 : data.id);
        });
    };
    var renderDataAccToLayout = function renderDataAccToLayout() {
        switch(listPresentationConfig.layoutName){
            case Constants/* COMMON_LAYOUT_TYPE.ONE */.o_.ONE:
            case Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layouts_Layout1, {
                    productName: productName,
                    imageUrl: productImage,
                    productUrl: productUrl,
                    childComp: getDataByOrder,
                    cardFrameConfig: props.cardFrameConfig,
                    listPresentationConfig: listPresentationConfig,
                    isContentCenter: isContentCenter
                });
            case Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layouts_Layout2, {
                    productName: productName,
                    imageUrl: productImage,
                    productUrl: productUrl,
                    childComp: getDataByOrder,
                    cardFrameConfig: props.cardFrameConfig,
                    listPresentationConfig: listPresentationConfig,
                    isContentCenter: isContentCenter
                });
            case Constants/* COMMON_LAYOUT_TYPE.FOUR */.o_.FOUR:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layouts_Layout4, {
                    productName: productName,
                    imageUrl: productImage,
                    productUrl: productUrl,
                    childComp: getDataByOrder,
                    cardAnimationClass: cardAnimationClass,
                    cardFrameConfig: props.cardFrameConfig,
                    isContentCenter: isContentCenter
                });
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref6.widgetContextState, selectedWidgetSessionState = _widgetContextState.selectedWidgetSessionState, widgets = _widgetContextState.widgets, activeWidgetId = _widgetContextState.activeWidgetId;
    var infoWrapperStyles = props.infoWrapperConfig || {};
    var isProductTestimonial = props.isProductTestimonial, listPresentationConfig = props.listPresentationConfig;
    var _testimonialData = props.testimonialData, review = _testimonialData.review, authorMedia = _testimonialData.authorMedia, ratingCount = _testimonialData.ratingCount, _productImage = _testimonialData.productImage, productImage = _productImage === void 0 ? "" : _productImage, _productName = _testimonialData.productName, productName = _productName === void 0 ? "" : _productName, _productUrl = _testimonialData.productUrl, productUrl = _productUrl === void 0 ? "" : _productUrl, _verifiedBuyer = _testimonialData.verifiedBuyer, verifiedBuyer = _verifiedBuyer === void 0 ? false : _verifiedBuyer;
    var reviewStyles = props.reviewConfig || {};
    var cardWidth = isProductTestimonial && props.isLayoutCarousel ? props.oneGridCellGeometry.width - 10 : props.oneGridCellGeometry.width;
    var _ref = props.authorInfoConfig || {}, tmp = _ref.authornameConfig, ref7 = tmp === void 0 ? {} : tmp, ref7 = ref7 !== null ? ref7 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), tmp1 = _ref.authorProfileConfig, ref8 = tmp1 === void 0 ? {} : tmp1, ref8 = ref8 !== null ? ref8 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), authornameStyles = (0,_extends/* default */.Z)({}, _ref.authornameConfig), authorProfileStyles = (0,_extends/* default */.Z)({}, _ref.authorProfileConfig);
    var ref9 = (0,useLayoutTypes/* useLayoutTypes */.V)({
        listPresentationConfig: listPresentationConfig
    }), isLayout6 = ref9.isLayout6, isLayout5 = ref9.isLayout5, isLayout4 = ref9.isLayout4;
    var ref10 = (0,react.useState)(Constants/* CARD_ANIMATION_CLASSES.BASE */.YI.BASE + Constants/* CARD_ANIMATION_CLASSES.INACTIVE */.YI.INACTIVE), cardAnimationClass = ref10[0], setCardAnimationClass = ref10[1];
    var shouldAdjustCardPaddingX = props.isMobile && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.numColumnsMobile) === 1 && !isProductTestimonial;
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(listPresentationConfig);
    var showBorder = cardWrapperConfigs.isCardLayout;
    var colorConfig = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.colors) === null || ref === void 0 ? void 0 : (ref2 = ref.colorSchemes) === null || ref2 === void 0 ? void 0 : ref2[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref1 = listPresentationConfig.colors) === null || ref1 === void 0 ? void 0 : ref1.selectedColorSchemeIndex];
    var authorImagePosition = (0,Utils/* getAuthorImagePositionInfo */.Px)({
        pos: (ref3 = props.cardFrameConfig) === null || ref3 === void 0 ? void 0 : ref3.authorImagePosition,
        isMobileAndL5: isLayout5 && props.isMobile
    });
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var isSelected = (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) === props.index && (props === null || props === void 0 ? void 0 : (ref4 = props.listPresentationConfig) === null || ref4 === void 0 ? void 0 : ref4.type) === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref5 = activeWidgetProps.listPresentation) === null || ref5 === void 0 ? void 0 : ref5.type);
    var showImageLoader = isSelected && selectedWidgetSessionState.isAvatarLoading;
    var ref11 = (0,Utils/* getStylesAndUtilsFromConfig */.l8)({
        isMobile: props === null || props === void 0 ? void 0 : props.isMobile,
        cardFrameConfig: props === null || props === void 0 ? void 0 : props.cardFrameConfig
    }), headlineStylesFromConfig = ref11.headlineStylesFromConfig, reviewStylesFromConfig = ref11.reviewStylesFromConfig, imageWidth = ref11.imageWidth, isContentCenter = ref11.isContentCenter, textAlignmentStyle = ref11.textAlignmentStyle, showImage = ref11.showImage, showRatings = ref11.showRatings;
    (0,react.useEffect)(function() {
        if (isLayout4) {
            var BASE = Constants/* CARD_ANIMATION_CLASSES.BASE */.YI.BASE, ACTIVE = Constants/* CARD_ANIMATION_CLASSES.ACTIVE */.YI.ACTIVE, INACTIVE = Constants/* CARD_ANIMATION_CLASSES.INACTIVE */.YI.INACTIVE;
            setCardAnimationClass(BASE + ((props === null || props === void 0 ? void 0 : props.isActiveCard) ? ACTIVE : INACTIVE));
        }
    }, [
        isLayout4,
        props === null || props === void 0 ? void 0 : props.isActiveCard
    ]);
    var wrapperStyling = (0,Utils/* getWrapperStyles */.p1)({
        showBorder: showBorder,
        listPresentationConfig: props === null || props === void 0 ? void 0 : props.listPresentationConfig,
        isSelected: isSelected,
        shouldAdjustCardPaddingX: shouldAdjustCardPaddingX
    });
    if (!(review === null || review === void 0 ? void 0 : review.trim())) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-relative tw-flex tw-flex-shrink-0 tw-items-start tw-justify-between tw-rounded-[8px]", cardWrapperConfigs.isCardLayout && "".concat(props.isMobile ? "tw-px-[14px] tw-py-[14px]" : "tw-p-[20px]"), wrapperStyling.className),
        style: (0,_object_spread/* default */.Z)({
            width: "".concat(cardWidth, "px")
        }, wrapperStyling.style),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-[5%]",
            children: [
                isSelected && !isProductTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute -tw-left-[1px] -tw-top-[1px] tw-z-50 tw-w-[108px] tw-bg-[#2F80ED] tw-px-[12px] tw-py-[4px] tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-z-50 tw-text-nowrap tw-text-[14px] tw-font-normal tw-text-[#fff]",
                        children: "Testimonial ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) + 1)
                    })
                }),
                authorImagePosition.left && !isProductTestimonial && renderAuthorImage(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("tw-flex tw-flex-1 tw-flex-col tw-justify-between", isContentCenter ? "tw-items-center" : "", authorImagePosition.left && !isProductTestimonial ? "tw-my-auto" : ""),
                    children: [
                        authorImagePosition.top && !isProductTestimonial && renderAuthorImage(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("tw-items tw-flex tw-flex-1 tw-flex-col tw-items-stretch tw-justify-between tw-overflow-hidden", authorImagePosition.top && (isLayout6 ? "tw-mt-[32px] !tw-gap-[20px]" : "tw-mt-[24px] !tw-gap-[16px]")),
                            style: infoWrapperStyles,
                            children: isProductTestimonial ? renderDataAccToLayout() : getDataByOrder()
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Components_Card = (Card);

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/ListPresentation.module.scss
var ListPresentation_module = __webpack_require__(939102);
var ListPresentation_module_default = /*#__PURE__*/__webpack_require__.n(ListPresentation_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useAutoScrollOrRotation.tsx
var useAutoScrollOrRotation = __webpack_require__(615030);
// EXTERNAL MODULE: ./src/containers/AdditionalPage/constant.ts
var constant = __webpack_require__(826061);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(101657);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(409669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/config/endpoints.js
var endpoints = __webpack_require__(951919);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/ProductTestimonials/utils.ts
var ProductTestimonials_utils = __webpack_require__(851759);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Testimonials.tsx





















var Testimonials = function() {
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref.widgetContextState, isBuilder = _widgetContextState.isBuilder, activeWidgetId = _widgetContextState.activeWidgetId, handleWidgetPropChange = ref.widgetContextHelpers.handleWidgetPropChange;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, isMobile = _state.isMobile, itemCountTotal = _state.itemCountTotal, listPresentationConfig = _state.listPresentationConfig, cardFrameConfig = _state.cardFrameConfig;
    var sectionContainerRef = data.refs.sectionContainerRef;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, oneGridCellGeometry = _generalValues.oneGridCellGeometry, showAutoRotation = _generalValues.showAutoRotation, columns = _generalValues.columns, gridGapAxis = _generalValues.gridGapAxis, containerTracks = _generalValues.containerTracks, isLayoutCarousel = _generalValues.isLayoutCarousel, isTestimonialListingPage = _generalValues.isTestimonialListingPage, carouselIndicatorConfigs = _generalValues.carouselIndicatorConfigs, viewAllItemsConfig = _generalValues.viewAllItemsConfig;
    var isCarousel = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === constant/* LAYOUT_TYPE.CAROUSEL */.y.CAROUSEL;
    var dataOrder = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.childElementOrder) || [];
    var isProductTestmonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */.G.PRODUCT_TESTIMONIAL;
    var testimonialsData = (0,Utils/* getViewableTestimonials */.EX)({
        cardFrameConfig: cardFrameConfig,
        isCarousel: isCarousel,
        isTestimonialListingPage: isTestimonialListingPage,
        containerTracks: containerTracks,
        isProductTestmonial: isProductTestmonial,
        viewAllItemsConfig: viewAllItemsConfig
    });
    var totalItems = testimonialsData === null || testimonialsData === void 0 ? void 0 : testimonialsData.length;
    var CONFIG_ACC_TYPE = isProductTestmonial ? ProductTestimonialsConfig.PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS : Constants/* CARD_DEFAULT_CONFIGS */.ko;
    var config = CONFIG_ACC_TYPE[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName];
    function getAllSelectedReviewData(selectedReviewIds) {
        return _getAllSelectedReviewData.apply(this, arguments);
    }
    function _getAllSelectedReviewData() {
        _getAllSelectedReviewData = (0,_async_to_generator/* default */.Z)(function(selectedReviewIds) {
            var ref, dataToSend, responseData, reviewData, updatedReviewData, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        dataToSend = {
                            store_id: storeData.store_id,
                            num_list: (0,_to_consumable_array/* default */.Z)(selectedReviewIds)
                        };
                        return [
                            4,
                            axios_default().post(endpoints/* ENDPOINT.PRODUCT_TESTIMONIAL.getPTestimonialById */.f.PRODUCT_TESTIMONIAL.getPTestimonialById, dataToSend)
                        ];
                    case 1:
                        responseData = _state.sent();
                        reviewData = JSON.parse((responseData === null || responseData === void 0 ? void 0 : (ref = responseData.data) === null || ref === void 0 ? void 0 : ref.data) || {});
                        updatedReviewData = (0,ProductTestimonials_utils/* getReviewDataStructure */.ek)({
                            review_rating: reviewData
                        });
                        cardFrameConfig.testimonialsList = updatedReviewData;
                        handleWidgetPropChange({
                            listPresentation: listPresentationConfig,
                            cardFrame: cardFrameConfig
                        }, activeWidgetId);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getAllSelectedReviewData.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        var selectedReviewIds = cardFrameConfig.selectedReviewsId;
        if (selectedReviewIds === null || selectedReviewIds === void 0 ? void 0 : selectedReviewIds.length) {
            getAllSelectedReviewData(selectedReviewIds);
        }
    }, [
        isProductTestmonial
    ]);
    var ref1 = (0,useAutoScrollOrRotation/* useAutoScrollOrRotation */.o)({
        listPresentationConfig: listPresentationConfig
    }), isAutoScrollEnabled = ref1.isAutoScrollEnabled, autoScrollTimer = ref1.autoScrollTimer;
    var effectiveTestimonialsData = showAutoRotation ? testimonialsData.concat(testimonialsData.slice(0, columns)) : testimonialsData;
    // used only in case of layout-4
    var activeTestimonialIdx = (0,Utils/* getActiveTestimonialIndex */.At)({
        carouselIndicatorConfigs: carouselIndicatorConfigs,
        totalItems: totalItems
    });
    var allTestimonialCards = effectiveTestimonialsData.map(function(testimonialData, index) {
        var testimonialIndex = index % totalItems;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_Card, (0,_object_spread/* default */.Z)({
            dataOrder: dataOrder,
            testimonialData: testimonialData,
            listPresentationConfig: listPresentationConfig,
            cardFrameConfig: cardFrameConfig,
            oneGridCellGeometry: oneGridCellGeometry,
            isBuilder: isBuilder,
            columns: columns,
            isProductTestimonial: isProductTestmonial,
            isMobile: isMobile,
            index: testimonialIndex,
            isActiveCard: testimonialIndex === activeTestimonialIdx,
            isLayoutCarousel: isLayoutCarousel,
            imageWrapperStyles: (0,Utils/* getImageWrapperStyles */.C_)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.imageShape, testimonialIndex)
        }, config), (testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.id) || index);
    });
    if (isCarousel && isAutoScrollEnabled) {
        var groupWidth = oneGridCellGeometry.width * itemCountTotal + itemCountTotal * gridGapAxis.columnGap;
        var testimonialCardWithWrapper = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                gap: gridGapAxis.columnGap,
                maxWidth: groupWidth,
                width: groupWidth,
                paddingRight: gridGapAxis.columnGap,
                animationDuration: autoScrollTimer * Math.ceil(totalItems / columns) + "s"
            },
            className: (ListPresentation_module_default()).group,
            children: allTestimonialCards
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                maxWidth: sectionContainerRef === null || sectionContainerRef === void 0 ? void 0 : sectionContainerRef.clientWidth
            },
            className: (0,bundle_mjs/* twMerge */.m6)((ListPresentation_module_default()).carousel, "tw-pb-[10px] tw-pt-[35px]"),
            children: [
                testimonialCardWithWrapper,
                testimonialCardWithWrapper,
                testimonialCardWithWrapper
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: allTestimonialCards
    });
};
/* harmony default export */ var Testimonials_Testimonials = (Testimonials);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/index.tsx



/***/ }),

/***/ 988583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ProductRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(414924);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(860437);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(802409);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(150066);



var ProductRating = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    displayName: "ProductRating",
    componentId: "sc-2332941-0"
})(function(props) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "&.".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].root */ .Z.root), {
        fontSize: props.fontSize || "16px",
        lineHeight: 1,
        height: props.fontSize || "16px"
    }), //   [`& .${ratingClasses.iconFilled}`]: {
    //     color: '#ff6d75',
    //   },
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].iconEmpty */ .Z.iconEmpty), {
        color: props.emptyIconColor || "#171C2A33"
    }), _obj;
});


/***/ }),

/***/ 851759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UR": function() { return /* binding */ getCategoryProductTestimonial; },
/* harmony export */   "XP": function() { return /* binding */ createCategoryTestimonialDropdownConfig; },
/* harmony export */   "ek": function() { return /* binding */ getReviewDataStructure; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(629815);

function getReviewDataStructure(data) {
    var review_rating = data.review_rating;
    var reviewData = review_rating === null || review_rating === void 0 ? void 0 : review_rating.map(function(data) {
        var ref = data || {}, _item_name = ref.item_name, item_name = _item_name === void 0 ? "" : _item_name, _item_url = ref.item_url, item_url = _item_url === void 0 ? "" : _item_url, _image_url = ref.image_url, image_url = _image_url === void 0 ? "" : _image_url, _review = ref.review, review = _review === void 0 ? "" : _review, _full_name = ref.full_name, full_name = _full_name === void 0 ? "" : _full_name, verified_buyer = ref.verified_buyer, review_date = ref.review_date, rating = ref.rating, avg_rating = ref.avg_rating, id = ref.id;
        return {
            productName: item_name,
            productUrl: item_url,
            productImage: image_url,
            headline: "",
            review: review,
            authorMedia: {
                type: "image",
                link: "https://codrops-1f606.kxcdn.com/codrops/wp-content/uploads/2020/02/04.jpg?x99913"
            },
            authorName: full_name,
            authorDesignation: "",
            ratingCount: rating,
            avgRating: avg_rating,
            date: review_date,
            isVisible: true,
            verifiedBuyer: verified_buyer,
            id: id
        };
    });
    return reviewData;
}
// Here pTestimonial is product testimonial and ptData is Product testimonial data
function getCategoryProductTestimonial(categoryPTestimonial) {
    var dropdownDownData = [];
    var catItemReviewMap = {};
    categoryPTestimonial === null || categoryPTestimonial === void 0 ? void 0 : categoryPTestimonial.forEach(function(ptData) {
        var category = ptData.category, items = ptData.items;
        dropdownDownData === null || dropdownDownData === void 0 ? void 0 : dropdownDownData.push({
            value: category.id,
            text: category.name
        });
        items === null || items === void 0 ? void 0 : items.forEach(function(ptItemData) {
            var ref, ref1;
            catItemReviewMap[category.id] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((catItemReviewMap === null || catItemReviewMap === void 0 ? void 0 : catItemReviewMap[category.id]) || []).concat([
                {
                    productImage: ptItemData === null || ptItemData === void 0 ? void 0 : ptItemData.image_url,
                    productName: ptItemData === null || ptItemData === void 0 ? void 0 : ptItemData.name,
                    productId: ptItemData === null || ptItemData === void 0 ? void 0 : ptItemData.id,
                    categoryId: category.id,
                    reviews: ptItemData === null || ptItemData === void 0 ? void 0 : (ref = ptItemData.store_item_review_rating) === null || ref === void 0 ? void 0 : ref.review_rating,
                    reviewsCount: ptItemData === null || ptItemData === void 0 ? void 0 : (ref1 = ptItemData.store_item_review_rating) === null || ref1 === void 0 ? void 0 : ref1.ratings_count
                }
            ]);
        });
    });
    return {
        dropdownDownData: dropdownDownData,
        catItemReviewMap: catItemReviewMap
    };
}
function createCategoryTestimonialDropdownConfig(dropdownData) {
    return {
        dropdownData: dropdownData,
        placeholder: "Select Category",
        customChildRender: false,
        key: "category",
        forCategory: true,
        customClass: "tw-w-[200px]"
    };
}


/***/ }),

/***/ 518042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ TestimonialRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ProductCard_muiStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(988583);
/* harmony import */ var _mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(528218);



var TestimonialRating = function(param) {
    var ratingCount = param.ratingCount, _color = param.color, color = _color === void 0 ? "#F9CC43" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DesignSystem_Widgets2_0_ProductCard_muiStyles__WEBPACK_IMPORTED_MODULE_1__/* .ProductRating */ .v, {
        value: ratingCount,
        sx: {
            color: color
        },
        fontSize: "20px",
        precision: 0.1,
        readOnly: true,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__["default"], {
            fontSize: "inherit"
        }),
        emptyIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_StarSharp__WEBPACK_IMPORTED_MODULE_2__["default"], {
            fontSize: "inherit"
        })
    });
};


/***/ }),

/***/ 939102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListPresentation_carousel__lyRBR","group":"ListPresentation_group___ECsm","scrolling":"ListPresentation_scrolling__8grpZ"};

/***/ }),

/***/ 740872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);